<script>
  import VueElementLoading from 'vue-element-loading'
  import {
    PlusIcon,
    MinusIcon,
    Edit3Icon,
    ExternalLinkIcon,
    EyeIcon,
    ClockIcon,
    DollarSignIcon ,
  } from 'vue-feather-icons'
  import {
    userMethods
  } from '@state/helpers'
  import {
    IconReturnsSupplier,
    IconReturnsCustomer,
    IconLoss,
    IconProfit,
  } from '@state/icon-helpers'
  import {
    doesUserHavePermission,
    doesUserHavePermissionOfAnySet,
  } from '@utils/permissions'

  export default {
    components: {
      VueElementLoading,
      PlusIcon,
      MinusIcon,
      Edit3Icon,
      ExternalLinkIcon,
      EyeIcon,
      ClockIcon,
      DollarSignIcon,
      IconReturnsSupplier,
      IconReturnsCustomer,
      IconLoss,
      IconProfit,
    },
    props: {
      customClasses: {
        type: String,
        default: ''
      },
      hideHeading: {
        type: Boolean,
        default: false
      },
      headingText: {
        type: String,
        default: 'List',
      },
      headingBackText: {
        type: String,
        default: null,
      },
      isInsideTabs:{
        type: Boolean,
        default: false
      },
      getData: {
        type: null,
        default: null,
      },
      fields: {
        type: Array,
        default: () => [],
      },
      transformData: {
        type: Function,
        default: row => row,
      },
      onToggle: {
        type: Function,
        default: null,
      },
      filter: {
        type: null,
        default: () => ({})
      },
      hideCreateAction: {
        type: Boolean,
        default: false,
      },
      showCreateChild: {
        type: Boolean,
        default: false,
      },
      dynamicallyHideCreateChild: {
        type: Function,
        default: null,
      },
      hideImportAction: {
        type: Boolean,
        default: false,
      },
      hideExportAction: {
        type: Boolean,
        default: false,
      },
      viewPermissions: {
        type: Array,
        default: null,
      },
      editPermissionsFunction: {
        type: Function,
        default: null,
      },
      editPermissionsArray: {
        type: Array,
        default: null,
      },
      editPermissions: {
        type: Array,
        default: null,
      },
      deletePermissions: {
        type: Array,
        default: null,
      },
      restorePermissions: {
        type: Array,
        default: null,
      },
      importAction: {
        type: null,
        default: null,
      },
      exportAction: {
        type: null,
        default: null,
      },
      importDownloadTemplateAction: {
        type: null,
        default: () => {},
      },
      importDownloadErrorAction: {
        type: null,
        default: () => {},
      },
      importType: {
        type: String,
        default: '',
      },
      importStatus: {
        type: null,
        default: () => ({}),
      },
      defaultFiltering:{
        type: Object,
        default: () =>({
          orderBy: 'id',
          sortedBy: 'desc',
          page: 1,
        })
      },
      disableDetail:{
        type: Boolean,
        default: false,
      },
      disableEdit:{
        type: Boolean,
        default: false,
      },
      stackedTier:{
        type: [String, Boolean],
        default: 'md',
      }
    },
    data() {
      return {
        isLoading: true,
        items: {},
        selectedItems: [],
        windowWidth: 0,
      }
    },
    computed: {
      hasTheadTop() {
        return !!this.$scopedSlots['thead-top']
      },
      hasCustomFoot() {
        return !!this.$scopedSlots['custom-foot']
      },
      isControlPressed(){
        return this.$store.state.keypress.isCtrl
      },
      displayableFields(){
        const remainingFields = this.fields.filter(el => {
          if (el.cull){
            return this.windowWidth >= el.cull
          }
          return true
        })
        return remainingFields
      },
      hasDisplayHeading(){
        return !this.hideHeading && !(this.headingBackText === null)
      }
    },
    watch: {
      filter () {
        this.loadData()
      }
    },
    async created() {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
      return this.loadData()
    },
    methods: {
      ...userMethods,
      doesUserHavePermission,
      doesUserHavePermissionOfAnySet,
      refreshSelected(){
        if (this.items && this.items.data && this.items.data.length > 0){
          const data = this.items.data.filter(el => el.selected)
          this.$set(this, 'selectedItems', data)
        }else{
          this.$set(this, 'selectedItems', [])
        }
        this.$emit('selected-update', this.selectedItems)
      },
      async loadData () {
        if (typeof this.getData !== 'function') {
          return
        }
        this.isLoading = true
        const { data } = await this.getData({
          ...this.defaultFiltering,
          ...this.filter,
        })
        data.data = data.data.map(this.transformData)
        this.items = data
        this.isLoading = false
      },
      async changePage (page) {
        this.filter.page = page
        return this.loadData()
      },
      hasEditPermision(value){
        if (this.disableEdit){
          return false
        }
        return ((this.editPermissions && doesUserHavePermission( this.getUserPermissions(), this.editPermissions, this.getUserType() ))
          || (this.editPermissionsArray && doesUserHavePermissionOfAnySet( this.getUserPermissions(), this.editPermissionsArray, this.getUserType() ))
          || (this.editPermissionsFunction && doesUserHavePermission( this.getUserPermissions(), this.editPermissionsFunction(value.type), this.getUserType() ))
          || (!this.editPermissionsFunction && !this.editPermissionsArray && !this.editPermissions) )
      },
      get(from, selector) {
        return selector
          // eslint-disable-next-line
        .replace(/\[([^\[\]]*)\]/g, '.$1.')
          .split('.')
          .filter(t => t !== '')
          .reduce((prev, cur) => prev && prev[cur], from)
      },
      async tryToImportProducts() {
        this.$emit('openImportProducts');
      },
      hideOnDetail(key){
        const reference = this.fields.find(el => el.key === key)
        if (reference && Object.prototype.hasOwnProperty.call(reference, 'hideOnDetail')){
          return reference.hideOnDetail
        }
        return false
      },
      toggleDetails (row) {
        this.$emit('toggle', row)
        if (this.onToggle) {
          this.onToggle(row, this.items);
        } else {
          row.toggleDetails();
        }
      },
      resolveField(fieldKey){
        if (this.fields.findIndex(el => el.key === fieldKey) !== -1){
          return this.fields.find(el => el.key === fieldKey)
        }
        return false
      },
      resolveClassByField(fieldKey){
        const field = this.resolveField(fieldKey);
        if (field && field.class){
          return field.class
        }
        return ''
      },
      resolveId(row){
        return `xero-img__${row.item.id}`
      },
      rowClass(item, type) {
        if (type === "row-details" && item._showDetails) return 'tw-border-l tw-border-r-2 tw-border-b-2 tw-border-primary'
        return ''
      },
      truncateTitle(title){
        if (title && typeof title === 'string'){
          return title.substring(0, 16)
        }
        return title
      },
      dontCull(key){
        const fieldsObject = this.fields.find(el => el.key === key)
        if (!!fieldsObject && Object.prototype.hasOwnProperty.call(fieldsObject, 'cull')){
          return this.windowWidth >= fieldsObject.cull
        }
        return true
      }
    },
  }
</script>

<template>
  <div class="grid-listing staf-list-content">
    <section
      v-if="hasDisplayHeading"
      class="tw-h-5 tw-pl-4 tw-no-underline tw-text-primary tw-w-fit">
      <article
        href="javascript:void(0)"
        @click="$emit('close')"> &lt; {{ headingBackText }} </article>
    </section>
    <div
      v-if="!hideHeading"
      class="lg:tw-max-h-[3.25rem] lg:tw-min-h-[3.25rem] tw-flex align-items-center justify-content-between heading-block tw-flex-col md:tw-flex-row"
      :class="{ 'pb-3': isInsideTabs, 'pd-b-10 mn-h-58': !isInsideTabs }">
      <div class="tw-flex align-items-center left-content md:tw-justify-start tw-flex-wrap tw-justify-center tw-gap-y-2">
        <h3 class="page-heading pr-3 pd-l-15 !tw-inline-block tw-whitespace-nowrap tw-text-primary">
          {{ headingText }}
        </h3>
        <div v-if="!hideCreateAction" class="vl tw-hidden md:tw-block" ></div>
        <a
          v-if="!hideCreateAction"
          class="btn btn-transparent btn-primary-link tw-p-u md:tw-px-4">
          <button class="btn btn-circle btn-add-new rounded-circle fl-al-center !tw-bg-primary !tw-text-white" @click="$emit('create-action')">
            <PlusIcon size="1.5x" />
          </button>
        </a>
        <div v-if="(importAction || exportAction) && (!hideImportAction || !hideExportAction)" class="vl tw-hidden md:tw-block" ></div>
        <div v-if="(importAction || exportAction) && (!hideImportAction || !hideExportAction)" class="tw-hidden md:tw-flex align-items-center csv-group-action">
          <BaseExportButton v-if="exportAction && !hideExportAction" :method="exportAction"/>
          <div v-if="importAction && !hideImportAction" :class="['dropdown-white', { 'mg-l-20': exportAction }]">
            <FabricDropdown
              id="dropdown-1"
              variant="link"
              right
              toggle-class="btn-dropdown-w">
              <template v-slot:button-content>
                <span class="btn-action mr-1">
                  <span class="ficon-settings-line"></span>
                </span>
              </template>
              <FabricDropdownElement v-if="$route.name === 'supplier-tabs' && $route.params.tab === 'products'" type="link" @click="tryToImportProducts">IMPORT XLSX</FabricDropdownElement>
              <FabricDropdownElement v-else type="link" @click="$customModal.show('import-excel')">IMPORT</FabricDropdownElement>
            </FabricDropdown>
          </div>
        </div>
      </div>

      <div
        class="
        tw-flex align-items-center justify-content-end right-content
        md:tw-pt-0 tw-pt-2
        md:tw-mr-6 lg:tw-mr-0
        tw-pl-u"
      >
        <BasePagination
          v-if="items.meta"
          :pagination="items.meta.pagination"
          :trigger-by-method="true"
          @method="changePage"
        />
      </div>
    </div>
    <div :class="['table-container tw-overflow-hidden', customClasses]">
      <b-table
        v-if="items.data"
        show-empty
        small
        hover
        :stacked="stackedTier"
        class="custom-table-grid"
        :tbody-tr-class="rowClass"
        responsive
        :items="items.data"
        :fields="displayableFields"
      >
        <template v-if="hasTheadTop" v-slot:thead-top="row">
          <slot name="thead-top" :item="row.item"></slot>
        </template>
        <template v-for="field in fields" v-slot:[`cell(${field.key})`]="row">
          <slot v-if="(!field.hideOnDetail || !row.detailsShowing) && dontCull(field.key)" :name="field.key" :row="row.item">
            <div v-if="field.dompurifyHtml" :key="`${field.key}_enc`" v-dompurify-html="get(row.item, field.key)"/>
            <div v-else :key="`${field.key}_raw`">
              {{ get(row.item, field.key) }}
            </div>
          </slot>
        </template>
        <template v-slot:cell(type)="row">
          <slot v-if="(!row.detailsShowing || !row.field.hideOnDetail) && dontCull('row')" name="type" :row="row.item">
            <section class="fl-left-right">
              <span>{{ get(row.item, 'type') }}</span>
              <span class="tw-inline-flex tw-flex-col tw-justify-center tw-min-w-[1.75rem]">
                <img
                  v-if="row.item.xeroImage"
                  :id="resolveId(row)"
                  class="tw-w-7 tw-h-7"
                  :src="row.item.xeroImage"
                  :title="row.item.xeroImageAlt"
                  :alt="row.item.xeroImageAlt" />
                <FabricTooltip
                  v-if="row.item.xeroImage"
                  :target="resolveId(row)"
                  triggers="hover">
                  {{row.item.xeroImageAlt}}
                </FabricTooltip>
              </span>
            </section>
          </slot>
        </template>
        <template v-slot:cell(description)="row">
          <slot v-if="dontCull('description')" name="description" :item="row.item">
            <section v-if="!row.detailsShowing && row.item" :class="resolveClassByField('description')">
              {{ row.item.description }}
            </section>
          </slot>
        </template>
        <template v-slot:cell(selected)="row">
          <slot v-if="dontCull('selected')" name="selected-column">
            <section class="fl-al-center tw-pt-1">
              <FabricCheckbox
                v-model="row.item.selected"
                no-label
                @update="refreshSelected"
              />
            </section>
          </slot>
        </template>
        <template v-slot:cell(flags)="row">
          <slot v-if="dontCull('flags')" name="flags" :item="row.item">
            <div class="tw-flex align-items-center justify-content-center">
              <span class="icon-orange-18 flag">
                <span class="ficon-flag" />
              </span>
            </div>
          </slot>
        </template>
        <template v-slot:cell(clock)="row">
          <slot v-if="dontCull('clock')" name="clock" :item="row.item">
            <div class="tw-flex align-items-center justify-content-center">
              <span class="icon-orange-18 flag">
                <ClockIcon size="18" class="custom-class"></ClockIcon>
              </span>
            </div>
          </slot>
        </template>
        <template v-slot:cell(returns)="row">
          <slot v-if="dontCull('returns')" name="returns" :item="row.item">
            <div class="tw-flex align-items-center justify-content-center tw-gap-x-2.5">
              <template v-if="!row.detailsShowing && row.item.typeIcon">
                <IconReturnsCustomer v-if="row.item.typeIcon === 'CUSTOMER'" disable-hover class="tw-w-6 tw-h-6"/>
                <IconReturnsSupplier v-if="row.item.typeIcon === 'SUPPLIER'" disable-hover class="tw-w-6 tw-h-6"/>
              </template>
              <template v-if="!row.detailsShowing && row.item.creditNoteIcon">
                <IconLoss v-if="row.item.creditNoteIcon === 'LOSS'" disable-hover class="tw-w-6 tw-h-6"/>
                <IconProfit v-if="row.item.creditNoteIcon === 'PROFIT'" disable-hover class="tw-w-6 tw-h-6"/>
              </template>
            </div>
          </slot>
        </template>
        <template v-slot:cell(project)="row">
          <slot v-if="row.item.project && row.item.project.name && row.item.project.id && dontCull('project') && (!row.detailsShowing || !hideOnDetail('project')) " name="name-column" :item="row.item">
            <router-link
              :to="{ name: 'edit-project', params: { id: row.item.project.id, tab: 'edit' } }"
            >
              {{ row.item.project.name }}
            </router-link>
          </slot>
          <span v-else-if="row.item.project && dontCull('project') && (!row.detailsShowing || !hideOnDetail('project')) ">{{ row.item.project }}</span>
        </template>
        <template v-slot:cell(title)="row">
          <section
            v-if="dontCull('title')"
            class="fl-left-right al-v-center tw-truncate">
            <slot name="name-column" :item="row.item">
              <div
                v-if="!disableDetail"
                class="tw-flex align-items-center curs-p tw-truncate tw-whitespace-nowrap tw-max-w-[20rem] xl:tw-max-w-u"
                @click="toggleDetails(row)">
                <button
                  v-if="!disableDetail"
                  type="button"
                  class="btn btn-secondary btn-sm button-show-info mr-2 !tw-z-20"
                >
                  <span v-if="row.detailsShowing" class="icon minus !tw-inline-block tw-z-10">
                    <MinusIcon size="13" class="tw-inline-flex"/>
                  </span>
                  <span v-if="!row.detailsShowing" class="icon plus !tw-inline-block tw-z-10">
                    <PlusIcon size="13" class="tw-inline-flex"/>
                  </span>
                </button>
                <span class="label-row tw-truncate" :class="resolveClassByField('title')" >
                  <span class="tw-block smModal:tw-hidden tw-truncate tw-max-w-[4rem] xxs:tw-max-w-[5rem] xs:tw-max-w-u ">{{ truncateTitle(row.item.title) }}</span>
                  <span class="tw-hidden smModal:tw-block tw-truncate tw-max-w-[11rem] xl:tw-max-w-u xl:tw-whitespace-normal">{{ row.item.title }}</span>
                </span>
              </div>
              <div v-else>
                <span class="tw-block smModal:tw-hidden tw-truncate tw-max-w-[4rem] xxs:tw-max-w-[5rem] xs:tw-max-w-u">{{ truncateTitle(row.item.title) }}</span>
                <span class="tw-hidden smModal:tw-block tw-truncate tw-max-w-[11rem] xl:tw-max-w-u xl:tw-whitespace-normal">{{ row.item.title }}</span>
              </div>
            </slot>
            <slot name="custom-title" :item="row.item"/>
          </section>
        </template>
        <template v-slot:cell(quanityEditable)="row">
          <slot v-if="dontCull('quanityEditable')" name="quanity-editable-column">
            <div contenteditable>{{ row.item.quanityEditable }}</div>
          </slot>
        </template>
        <template v-slot:cell(retailEditable)="row">
          <slot v-if="dontCull('retailEditable')" name="retail-editable-column">
            <div contenteditable>{{ row.item.retailEditable }}</div>
          </slot>
        </template>
        <template v-slot:cell(markupEditable)="row">
          <slot v-if="dontCull('markupEditable')" name="markup-editable-column">
            <div contenteditable>{{ row.item.markupEditable }}</div>
          </slot>
        </template>
        <template v-slot:cell(totalEditable)="row">
          <slot v-if="dontCull('totalEditable')" name="total-editable-column">
            <div contenteditable>{{ row.item.totalEditable }}</div>
          </slot>
        </template>
        <template v-slot:cell(credit-totals)="row">
          <slot v-if="dontCull('credit-totals')" name="credit-totals" :item="row.item">
            <div>
              <span v-if="!row.detailsShowing && row.item.total" :class="[row.item.isCreditTotalPositive ? 'text-negative' : 'text-positive']">{{ row.item.total }}</span>
            </div>
          </slot>
        </template>
        <template v-slot:cell(status)="row">
          <slot v-if="!row.detailsShowing && row.item && dontCull('status')" name="row-status" :item="row.item">
            <BaseStatusChip :status="row.item.status"/>
          </slot>
        </template>
        <template v-slot:cell(actions)="row">
          <slot v-if="!row.detailsShowing && dontCull('actions')" name="actions" :item="row.item">
            <div class="tw-flex align-items-center justify-content-center">
              <button
                v-if="!disableDetail"
                type="button"
                class="btn btn-secondary button-transparent preview mr-2 ml-2"
                @click="toggleDetails(row)"
              >
                <EyeIcon size="1.5x"/>
              </button>
              <button
                v-if="hasEditPermision(row.item) && !isControlPressed"
                type="button"
                class="btn btn-secondary button-transparent edit pd-0 ml-2 mr-2"
                @click="$emit('edit-action', { ...row.item, newTab: false })"
              >
                <Edit3Icon size="1.5x"/>
              </button>
              <button
                v-if="hasEditPermision(row.item) && isControlPressed"
                type="button"
                class="btn btn-secondary button-transparent edit pd-0 ml-2 mr-2"
                @click="$emit('edit-action', { ...row.item, newTab: true })"
              >
                <ExternalLinkIcon size="1.5x"/>
              </button>
              <slot v-if="hasEditPermision(row.item)" name="custom-action" :item="row.item"/>
              <button
                v-if="(hasEditPermision(row.item)) && (showCreateChild) && (dynamicallyHideCreateChild(row.item))"
                type="button"
                class="btn btn-secondary button-transparent edit pd-0 ml-2 mr-2 f-h-24"
                @click="$emit('edit-action', { ...row.item, newTab: true })"
              >
                <span 
                  class="icon-wrapper-feather"
                ><DollarSignIcon 
                  size="1.1x" 
                  class="fl-inline icon-wrapped-centered" 
                  @click="$emit('create-child-action', row.item)"
                /></span>
              </button>
            </div>
          </slot>
        </template>
        <template v-slot:cell(address)="row">
          <slot v-if="dontCull('address')">
            <div :class="{ invisible: fields.find(el => el.key === 'address').hideOnDetail && row.detailsShowing }">{{ row.item.address | getStringFromObjectAddress }}</div>
          </slot>
        </template>
        <template v-slot:cell(arrive_by)="row">
          <section v-if="dontCull('arrive_by') && (!hideOnDetail('arrive_by') || !row.detailsShowing)">
            <BaseDate :date="row.item.arrive_by" />
          </section>
        </template>
        <template v-slot:cell(created)="row">
          <section v-if="dontCull('created') && (!hideOnDetail('created') || !row.detailsShowing)">
            <BaseDate :date="row.item.created" />
          </section>
        </template>
        <template v-slot:row-details="row">
          <slot name="row-details" :item="row.item" :row="row"></slot>
        </template>
        <template v-if="hasCustomFoot" v-slot:custom-foot="row">
          <slot name="custom-foot" :item="row.item"></slot>
        </template>
      </b-table>
    </div>
    <div class="navigation">
      <div class="align-items-center md:tw-justify-end mt-3 pb-3 row tw-justify-center">
        <div class="md:tw-mr-4 tw-mr-0">
          <div class="tw-flex align-items-center justify-content-end">
            <BasePagination
              v-if="items.meta"
              :pagination="items.meta.pagination"
              :trigger-by-method="true"
              @method="changePage"
            />
          </div>
        </div>
      </div>
    </div>
    <VueElementLoading class="!tw-z-auto" :active="isLoading" spinner="bar-fade-scale"/>
    <BaseImportExcel
      v-if="importAction"
      :status="importStatus"
      :type="importType"
      @onFileChange="importAction"
      @onCancel="$emit('onCancel')"
      @downloadError="importDownloadErrorAction"
      @downloadTemplate="importDownloadTemplateAction"
    />
  </div>
</template>
